import { DateTime } from 'luxon'

import { countryCodeToName } from '@/utils/helpers'

import { UserStoryRole } from '@/queries/constants'
import UserQ from '@/queries/UserQ'
import UserStoryQ from '@/queries/UserStoryQ'
import type { Query } from '@/client/query'

import type { ViewStoryAttributes } from '@/components/Stories/ViewStoryModal'

const DATE_FORMAT = 'LLL d, y'

export const STORY_QUERY_KEY = 'id'

export function getStoryAttributes(story: Query): ViewStoryAttributes {
  const author = story.one(UserStoryQ.getUser())
  const country = countryCodeToName(author(UserQ.country)) ?? ''
  const userId = author(UserQ.id) ?? 0
  const username = author(UserQ.username)
  const name = author(UserQ.display_name) ?? ''
  const avatarUrl = author(UserQ.avatar_url) ?? ''
  const progressionLevel = author(UserQ.progression_level)
  const id = story(UserStoryQ.id) ?? 0
  const title = story(UserStoryQ.title) ?? ''
  const body = story(UserStoryQ.body) ?? ''
  const role = story(UserStoryQ.role) === UserStoryRole.Learner ? 'Learner' : 'Tutor'
  const clapCount = story(UserStoryQ.clap_count) ?? 0
  const dateTime = DateTime.fromISO(story(UserStoryQ.created_at) ?? '')
  const date = dateTime.toFormat(DATE_FORMAT)

  return {
    id,
    country,
    userId,
    username,
    name,
    title,
    body,
    role,
    clapCount,
    date,
    avatarUrl,
    progressionLevel,
  }
}
